/* eslint-disable */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import applicationstagesLabels from "../labels/applicationstages_en.json"
import ImportDataModal from "./ImportDataModal"
import { marksheetTemlateDownload, retotalingRequestDownload } from '../actions/applicationStagesAction';

const DataImport = (props) => {
    const dispatch = useDispatch();
    const [showImportDocList, setImportDocumentList] = useState(false)

    const downloadTemplate = () => {
        if (props && props.type === 'retotaling_download') {
            dispatch(retotalingRequestDownload(props.advtId, props.postId))
        }
        else {
            dispatch(marksheetTemlateDownload())
        }
    };

    const handledUploadList = () => {
        setImportDocumentList(true)
    };

    return (
        <div className="d-flex justify-content-center">
            <main role="main" className="col-sm-9 col-md-11 col-lg-12 " id="main_block">
                <div className='pt-2 pb-2'>
                    <div className='text-end pe-1'>
                        {props && props.type !== 'retotaling_download' && <button type='button' className='btn btn-sm btn-primary' onClick={handledUploadList}>{props.upload_button_label ? props.upload_button_label : applicationstagesLabels.UPLOAD_LIST}</button>}
                        {props && props.type !== 'retotaling_upload' && <button type='button' className='btn btn-sm btn-primary' onClick={downloadTemplate}>{props.download_button_label ? props.download_button_label : applicationstagesLabels.DOWNLOAD_TEMPLATE}</button>}
                    </div>

                </div>
            </main>

            <ImportDataModal
                showImportDocList={showImportDocList}
                setImportDocumentList={setImportDocumentList}
                advtNo={props.advtId}
                type={props && props.type}
            />
        </div>
    )
}

export default DataImport;